import type { FaireProductEntity } from "../../entity_types/product";

export const p_y97tdhtda5: FaireProductEntity = {
  token: "p_y97tdhtda5",
  type: "product",
  name: "Heirloom Tomato Candle",
  brandToken: "b_6bmpg4myaw",
  brandName: "Ollie Blossom",
  imageUrl:
    "https://cdn.faire.com/fastly/72f924a6a543aaf80e54a9fe5f122e6e120f37f5d4b206f43b1e757ceafad345.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/32655e30e8a362d49e705659e30d9ecb56ad470f8674de4e0e17f7f16fafbe20.jpeg",
    "https://cdn.faire.com/fastly/303acb798df918256bc1e2e8abd99ad4f89920c98dbe77c5952dcaab8ce2f325.jpeg",
    "https://cdn.faire.com/fastly/3defb218ce687f413ed375dffb8f8808a32ee4941de1e2a19c5438987b834300.png",
    "https://cdn.faire.com/fastly/3fbea0b118326ced58874133df6b21a06c1378b6b43db0ec241acc8bc4488581.png",
  ],
  priceDollars: 9.5,
  description:
    "This scent carries the essence of a summer garden: vibrant greens, hand-picked herbs, and a touch of delicate spice. Rooted with scents of heirloom tomatoes, wild-harvested Atlanta tarragon, and elevated with Madagascar black pepper essential oil.\n\n6.5 oz and 2.5 oz 100% organic soy wax. Formulated without known endocrine-disrupting chemicals, using only premium, clean fragrance oils.\n",
  tags: [],
  msrpDollars: 19,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-09-01T22:12:56.644Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
